module.exports = __webpack_public_path__ + "static/media/sub-card-label-4-over.1e9aaf6f.svg";